<template>
    <div class="u-message">
        <div :class="[message.button && message.button.length !== 0 ? 'u-message__body' : 'u-message__comment']">
            <strong class="u-message__name r-strong" v-html="message.title"></strong>
            <div class="u-message__content">
                <p v-html="message.description"></p>
            </div>
        </div>
        <div class="u-message__action" v-if="message.button.title">
            <a :href="message.button.link" class="r-link button" v-html="message.button.title"></a>
        </div>
        <div class="u-message__action" v-if="message.button.user_id">
            <button class="r-button button" @click="closeMessange(message.button.nameMessage)">Закрыть</button>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'DashboardMessage',
		props: {
			message: {
				type: Object,
				required: true
			},
		},
        methods: {
            closeMessange(nameMessage) {
                this.$emit('remove', this.message.button.user_id, nameMessage);
            },
        }
	}
</script>
